module.exports = __webpack_public_path__ + "static/img/sindex-admin.377820c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/sindex-admin.jpg
// module id = fycZ
// module chunks = 1